import type {
  BenefitTypeAdminDto,
  BenefitTypeRequestDto,
  Page,
  PageQuery,
} from '@kardume/types';
import api from './http';

/**
 * Catálogo de tipos de benefício (card #361).
 *
 * O motor do card #188 foi construído para que abrir um tipo novo seja um
 * `INSERT`, não um deploy. Este cliente é o que torna esse `INSERT` possível
 * pelo backoffice, no mesmo formato do catálogo de cláusulas de anúncio
 * (`BackofficePromotionRuleTemplateController`).
 *
 * A rota devolve **inclusive os inativos**: um tipo desativado sai do
 * formulário do lojista e continua legível nos anúncios que já o usam, então a
 * operação precisa enxergá-lo para reativar ou corrigir a frase.
 */
export const backofficeBenefitTypeApi = {
  list(query?: PageQuery): Promise<Page<BenefitTypeAdminDto>> {
    return api
      .get<Page<BenefitTypeAdminDto>>('/v1/backoffice/benefit-types', {
        params: {
          page: query?.page ?? 0,
          size: query?.size ?? 100,
          ...(query?.sort ? { sort: query.sort } : {}),
          ...(query?.query ? { query: query.query } : {}),
        },
      })
      .then((r) => r.data);
  },

  /** `code` e `valueShape` só são aceitos aqui - depois de criado, nenhum muda. */
  create(payload: BenefitTypeRequestDto): Promise<BenefitTypeAdminDto> {
    return api.post<BenefitTypeAdminDto>('/v1/backoffice/benefit-types', payload).then((r) => r.data);
  },

  update(id: string, payload: BenefitTypeRequestDto): Promise<BenefitTypeAdminDto> {
    return api
      .put<BenefitTypeAdminDto>(`/v1/backoffice/benefit-types/${id}`, payload)
      .then((r) => r.data);
  },

  /** Soft delete. O core recusa quando há anúncio apontando para o tipo. */
  remove(id: string): Promise<void> {
    return api.delete(`/v1/backoffice/benefit-types/${id}`).then(() => undefined);
  },
};
